import {FC} from 'react';
import Box from '@mui/material/Box';
import {Plan} from "@memaro/api"
import {plans} from "../../../constants/profile.ts";
import Card from './Card.tsx';

type SelectorProps = {
    availablePlans: Plan[];
    selected: Plan | undefined;
    onSelect: (plan: Plan) => void;
}

const Selector: FC<SelectorProps> = ({availablePlans, selected, onSelect}) => {
    return (
        <Box sx={{width: '100%', height: "100%", overflowX: 'auto'}}>
            <Box sx={{
                display: 'flex',
                flexDirection: "row",
                gap: 4,
                justifyContent: 'center',
                overflowX: 'auto',
                flexWrap: 'nowrap',
                paddingLeft: 2,
                paddingRight: 2,
                paddingBottom: 2,
                minWidth: 'max-content'
            }}>
                {plans.map((plan) => (
                    <Card
                        key={plan.plan}
                        plan={plan}
                        disabled={!availablePlans.includes(plan.plan)}
                        isSelected={selected === plan.plan}
                        onClick={onSelect}
                    />
                ))}
            </Box>
        </Box>
    );
};

export default Selector;
